import { versionDate } from './versionDate';

export const environment = {
  environmentType: 'dev',
  apiUrl: 'https://dev.provider-api.goadroit.com/v1',
  client_id:
    '783896173032-21kqrb7703du55k95sfg963pvt12uism.apps.googleusercontent.com',
  localDomain: 'https://dev.provider.goadroit.com',
  versionDate,
  rideWaypointsEtaRootCollection: 'dev_jobs',
  partnerRootCollection: 'dev_partners',
  firebaseProjectId: 'adroit-prod-cloud',

  //Dispatch package env.
   dispatchUrl: 'https://dev.dispatch-api.goadroit.com/v1/dispatch',
   dispatchRidesCollection: 'dispatch/dev/read',
   dispatchAdrAdminUrl: 'https://dev.admin.goadroit.com',
   dispatchProduction: false,
   dispatchMapDetailsCollection: 'dispatch/dev/map_details',
   dispatchPartnerCollection: 'dev_partners',
   dispatchJobsCollection: 'dev_jobs',
   dispatchConversationsCollection: 'dev_conversations',
   rideMapZoomLevel: 13,
    isLocal: false,
    cameraStatusesCollection: 'vehicles/dev/camera_status',
  redirectUri: 'https://dev.provider.goadroit.com/login',
  projectName: 'adr-provider',
};
